"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInWebview = void 0;
function isInWebview() {
    var _a, _b;
    if (((_b = (_a = window === null || window === void 0 ? void 0 : window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.survey) || (window === null || window === void 0 ? void 0 : window.pythiaBridge)) {
        return true;
    }
    return false;
}
exports.isInWebview = isInWebview;
